export var ClientTimelineType;
(function (ClientTimelineType) {
    ClientTimelineType["Ongoing"] = "Ongoing";
    ClientTimelineType["Flexible"] = "Flexible";
    ClientTimelineType["Specific"] = "Specific";
    ClientTimelineType["SelfPaced"] = "SelfPaced";
})(ClientTimelineType || (ClientTimelineType = {}));
export var ClientDurationUnit;
(function (ClientDurationUnit) {
    ClientDurationUnit["DAYS"] = "DAYS";
    ClientDurationUnit["WEEKS"] = "WEEKS";
})(ClientDurationUnit || (ClientDurationUnit = {}));
export * from './react';
//# sourceMappingURL=index.js.map